import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { interval } from 'patronum'
import { driverModel } from '~/entities/common/Driver'
import { Driver, DriverAttributes } from '~/shared/api'
import { DriverStatus } from '~/shared/config/enums'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.common.driver.edit')
export const Gate = createGate()

sample({
  clock: driverModel.$id,
  filter: isString,
  target: driverModel.requestDriverFx,
})

/* Update status */
const intervalStarted = domain.createEvent()
const intervalStopped = domain.createEvent()
const { tick } = interval({
  timeout: 15000,
  start: intervalStarted,
  stop: intervalStopped,
  leading: false,
  trailing: false,
})
const requestStatusFx = domain.createEffect<string, Driver>({
  async handler(id) {
    const response = await Driver.option('fields[drivers]', 'status').find(id)
    const driver = response.getData()
    if (!driver) throw new Error('Driver not found')
    return driver
  },
})
sample({
  clock: tick,
  source: driverModel.$id,
  filter: isString,
  target: requestStatusFx,
})
sample({
  clock: Gate.open,
  target: intervalStarted,
})
sample({
  clock: Gate.close,
  target: intervalStopped,
})
sample({
  clock: driverModel.$driver,
  filter(driver) {
    const status = driver?.getStatus() as DriverStatus
    return [
      DriverStatus.APPROVED,
      DriverStatus.REJECTED,
      DriverStatus.WORKS,
      DriverStatus.FIRED,
    ].includes(status)
  },
  target: intervalStopped,
})
sample({
  clock: requestStatusFx.doneData,
  fn(driver) {
    return {
      id: driver.getApiId() as string,
      status: driver.getStatus() as DriverAttributes['status'],
    }
  },
  target: driverModel.driverStatusUpdated,
})

export const $checksLoading = createStore(false)
  .on([driverModel.retryAllChecksFx, driverModel.cancelAllChecksFx], () => true)
  .on(requestStatusFx.doneData, () => false)

sample({
  clock: [
    driverModel.retryAllChecksFx.doneData,
    driverModel.cancelAllChecksFx.doneData,
  ],
  source: driverModel.$id,
  filter: isString,
  target: requestStatusFx,
})
